import React from "react";
import Logo from "../../Assets/Images/logo.png"; // Ensure the path is correct
import "./sidenav.css";
import { NavLink } from "react-router-dom";
import ProfileDropdown from "../ProfileDropdown/ProfileDropdown";
import { useTheme } from "../../context/ThemeContext"; // Import the theme hook

function Sidenav({ userId, userRole, isCollapsed, userDepartment }) {
  const { theme, toggleTheme } = useTheme(); // Use the theme context
  const getNavLinkClassName = ({ isActive }) => `menu-item ${isActive ? "active" : ""}`;

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Logo Section */}
      <div className="logo">
        <img src={Logo} alt="Company Logo" />
      </div>
        {/* Theme Toggle Button */}
        <div className="theme-toggle">
        <button onClick={toggleTheme} className="toggle-btn">
          {theme === "light" ? (
            <i className="fa-solid fa-sun"></i>
          ) : (
            <i className="fa-solid fa-moon"></i>
          )}
          {!isCollapsed && <span>{theme === "light" ? "Light Mode" : "Dark Mode"}</span>}
        </button>
      </div>
      <hr className="divider" />

      {/* Main Menu */}
      <div className={`main-menu ${isCollapsed ? "collapsed" : ""}`}>
        <ul>
          {/* Admin-Only Links */}
          {userRole === "administrator" && (
            <>
              <li>
                <NavLink to="/admin" className={getNavLinkClassName}>
                  <i className="fa-solid fa-user-gear"></i>
                  {!isCollapsed && <span>Admin</span>}
                </NavLink>
              </li>
              <li>
                <NavLink to="/employee-dashboard" className={getNavLinkClassName}>
                  <i className="fa-regular fa-address-card"></i>
                  {!isCollapsed && <span>EIM</span>}
                </NavLink>
              </li>
            </>
          )}

          {/* Common Links */}
          <li>
            <NavLink to="/" className={getNavLinkClassName}>
              <i className="fa-solid fa-house"></i>
              {!isCollapsed && <span>Dashboard</span>}
            </NavLink>
          </li>

          {/* Conditional Links Based on Role/Department */}
          {(userRole === "administrator" || userDepartment === "Sales") && (
            <li>
              <NavLink to={`/project-table/${userId}`} className={getNavLinkClassName}>
                <i className="fa-solid fa-table-list"></i>
                {!isCollapsed && <span>Project Tracker</span>}
              </NavLink>
            </li>
          )}

          {/* Conditional Links Based on Role/Department */}
          {(userRole === "administrator" || userDepartment === "Sales") && (
            <li>
              <NavLink to={`/order-list/${userId}`} className={getNavLinkClassName}>
                <i className="fa-regular fa-clipboard"></i>
                {!isCollapsed && <span>Order List</span>}
              </NavLink>
            </li>
          )}

          {(userRole === "administrator" || ["Service", "Calibration"].includes(userDepartment)) && (
            <li>
              <NavLink to={`/service-tracker/${userId}`} className={getNavLinkClassName}>
                <i className="fa-solid fa-screwdriver-wrench"></i>
                {!isCollapsed && <span>Service Tracker</span>}
              </NavLink>
            </li>
          )}

          {/* <li>
            <NavLink to={`/404-error`} className={getNavLinkClassName}> */}
            {/* <NavLink to={`/attendance`} className={getNavLinkClassName}> */}
              {/* <i className="fa-solid fa-clipboard-user"></i>
              {!isCollapsed && <span>Attendance</span>}
            </NavLink>
          </li> */}

          <li>
            <NavLink to={`/organization`} className={getNavLinkClassName}>
              <i className="fa-solid fa-users"></i>
              {!isCollapsed && <span>Organization</span>}
            </NavLink>
          </li>

          {userRole === "administrator" && (
            <li>
              <NavLink to={`/my-tasks`} className={getNavLinkClassName}>
                <i className="fa-solid fa-bell"></i>
                {!isCollapsed && <span>Assign Task</span>}
              </NavLink>
            </li>
          )}
        </ul>
      </div>

      <hr className="divider" />

      {/* Profile Section */}
      <div className="profile-section">
        <ProfileDropdown isCollapsed={isCollapsed} />
      </div>

    
    </div>
  );
}

export default Sidenav;
